import { FC, HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";

import ImageTextCard from "@/components/cards/ImageTextCard";
import { ICard } from "../home/ServicesSection";
import SectionHeader from "../common/SectionHeader";
import RevealOnScroll from "@/components/common/RevealOnScroll";

// ---------------------------------------------------------------------------------

type ICardSectionProps = HTMLAttributes<HTMLDivElement> & {
  heading?: string;
  description?: ReactNode;
  cards?: ICard[];
};

const CardSection: FC<ICardSectionProps> = ({
  heading,
  description,
  cards,
  className,
  ...other
}) => {
  return (
    <section
      className={clsx("container py-14 md:py-20 xl:py-24", className)}
      {...other}
    >
      <div className="rounded-2xl bg-primary-100 px-5 py-10 md:px-8 lg:py-16 xl:px-12 xl:py-20">
        {(!!heading || !!description) && (
          <RevealOnScroll>
            <SectionHeader
              title={heading}
              subtitle={description}
              align="left"
              className="mb-8 md:mb-12"
            />
          </RevealOnScroll>
        )}

        <div className="grid grid-cols-12 gap-5 md:gap-x-8 lg:gap-y-8">
          {cards?.map((card, idx) => (
            <RevealOnScroll
              key={idx}
              index={idx}
              className="col-span-12 h-full md:col-span-6 xl:col-span-4"
            >
              <ImageTextCard
                icon={card.icon}
                heading={card.heading}
                description={card.description}
                className="h-full rounded-2xl p-6 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
              />
            </RevealOnScroll>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CardSection;
